module.exports = __webpack_public_path__ + "img/arrow-right-btn-mouseover.36ff068d.svg";